import { create } from 'zustand';
import { Company } from '@/models/company';
import { useNavigationStore } from './navigation-store';

interface CompanyState {
  activeCompany: Company | null;
  setActiveCompany: (company: Company | null) => void;
}

// Note: Persistence removed to match Vue behavior - user must select a space each session
export const useCompanyStore = create<CompanyState>()((set, get) => ({
  activeCompany: null,
  setActiveCompany: (company) => {
    const currentCompany = get().activeCompany;
    
    // Reset navigation when switching to a different company
    if (company?.Id !== currentCompany?.Id) {
      useNavigationStore.getState().reset();
    }
    
    set({ activeCompany: company });
  },
}));
